import * as Rx from "rxjs/Rx";

class EventSubject {
  subject: Rx.Subject<Event>;
  type: string;

  constructor(evtType: string) {
    this.type = evtType;
    this.subject = new Rx.Subject();
  }
}

class EventSubscription {
  id: string;
  subscription: Rx.Subscription;

  constructor(id: string, subscription: Rx.Subscription) {
    this.id = id;
    this.subscription = subscription;
  }
}

class Bus {
  private subscriptions: Array<EventSubscription> = new Array<EventSubscription>();
  private subjects: Array<EventSubject> = [];

  publish(eventType: string, target: any) {
    console.info("Event " + eventType, target);

    const event = new Event(eventType);

    if (target) event.target = target;

    for (const eventSubsject of this.subjects) {
      // Trigger for matching subjects
      if (event.type.indexOf(eventSubsject.type) > -1) {
        eventSubsject.subject.next(event);
      }
    }
  }

  subscribe(evtType: string, fn: any) {
    console.info("Subscribe on bus for " + evtType);

    let sub = this.subjects.filter((elt) => elt.type === evtType)[0];

    if (!sub) {
      this.subjects.push((sub = new EventSubject(evtType)));
    }

    const subId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    this.subscriptions.push(new EventSubscription(subId, sub.subject.subscribe({ next: (evt) => fn(evt) })));

    return subId;
  }

  unsubscribe(subId: string) {
    const subscript = this.subscriptions.filter((elt) => elt.id === subId)[0];

    if (subscript) {
      subscript.subscription.unsubscribe();
      this.subscriptions.splice(this.subscriptions.indexOf(subscript), 1);

      console.info("Unsubscribe from bus");
    } else {
      console.warn("Can't unsubscribe from bus");
    }
  }
}

export class Event {
  _type: string;
  _target?: any;

  constructor(type: string) {
    this._type = type;
  }

  get type() {
    return this._type;
  }

  get target() {
    return this._target;
  }

  set target(val) {
    this._target = val;
  }
}

export const Events = {
  msg: "global.message",
  study_finished: "study.finished",
  study_next: "study.next",
  obs_showregion: "obs.showregion",
};

const EventBus = new Bus();

export default EventBus;
